import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "@/store";
import { getToken, removeToken } from "@/utils/auth";
import router from "@/router/index";
import i18n from "@/lang";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 300000,
});

service.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = token;
    }
    const lang = store.getters.language;
    config.headers["lang"] =
      lang || navigator.language || navigator.browserLanguage;
    // config.headers['UA'] = 'Web'
    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      if (res.code === 401) {
        // 请重新登录
        MessageBox.confirm(i18n.t("info.login.again"), "确认登录", {
          confirmButtonText: "重新登录",
          cancelButtonText: i18n.t("operation.button.cancel"), //取消
          type: "warning",
        })
          .then(() => {
            const redirect = router.history.current.fullPath;
            router.push({ path: "/login?redirect=" + redirect || "" });
          })
          .catch(() => {
            router.push({ path: "/login" });
          });
      } else if (res.code === 900) {
        MessageBox.alert(
          i18n.t("页面更新，请重新登录").toString(),
          i18n.t("页面更新").toString(),
          {
            confirmButtonText: i18n.t("button.confirm").toString(), //确定
            showClose: false,
            callback: () => {
              removeToken();
              window.location.reload();
            },
          }
        );
      } else {
        Message({
          type: "error",
          message: i18n.t(res.message) || "业务处理失败",
          duration: 6000,
          showClose: true,
        });
      }
      console.log(res.message);
      return Promise.reject(new Error(i18n.t(res.message) || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error);
    Message({
      type: "error",
      message: i18n.t(error.message) || "网络请求异常",
    });
    return Promise.reject(error);
  }
);

export default service;
